<template>
    <div
        class="content-wrapper mainWrapper"
    >
        <template
            v-if="userAllowedToAccess">
            <section
                v-if="name"
                class="content-header pageHeader"
            >
                <ol
                    v-if="breadcrumb"
                    class="breadcrumb"
                >
                    <li>
                        <router-link
                            to="/"
                            class="open"
                        >
                            <i class="ti-home"></i>
                        </router-link>
                    </li>

                    <li
                        v-for="subRoute in breadcrumbSubRoutes"
                        :key="subRoute.to"
                    >
                        <router-link :to="subRoute.to">
                            {{ subRoute.name }}
                        </router-link>
                    </li>

                    <li class="active">
                        <a href="#">
                            {{ name }}
                        </a>
                    </li>
                </ol>
                <h1>{{ name }}</h1>
            </section>
            <section class="">

                <div
                    v-if="modelsLoaded"
                    :class="scopeClass"
                    class="simple-layout"
                >
                    <div
                        v-if="indicators.length || imgCover"
                        v-loading="loading"
                        :class="['header', burgerMenuClosed ? 'menuClosed' : 'menuOpened']"
                    >
                        <div
                            v-if="imgCover"
                            :style="{backgroundImage: `url(${backgroundImg})`, backgroundPositionY: `${imgPosY}px`}"
                            class="blured backgroundImage">
                        </div>
                        <div class="projectHeaderContent">
                            <el-row
                                type="flex"
                                align="middle"
                            >
                                <el-col
                                    v-for="(indicator, index) in indicators"
                                    :key="index"
                                    :span="24/indicators.length"
                                    class="text-center"
                                >
                                    <div class="number">{{ indicator.title }}</div>
                                    <span class="desc">{{ indicator.subtitle }}</span>
                                </el-col>
                            </el-row>
                        </div>
                    </div>

                    <main
                        :class="[burgerMenuClosed ? 'simpleLayoutMainMenuClosed' : '']"
                        class="simple-layout-main"
                        style=""
                    >
                        <slot></slot>
                    </main>
                </div>
                <div
                    v-else
                    class="simple-layout"
                >
                    <p>{{ getVerbose('simple_layout_loading') }}</p>
                </div>

        <!--         <div class="box">
                    <div class="box-body" style="min-height: 200px;">

                        <div class="col-sm-12">
                            <h3>Settings</h3>
                        </div>
                    </div>
                </div> -->
            </section>
        </template>
        <template
            v-else>
                <el-alert
                    :title="_userNotAllowedToAccessMessage"
                    type="info"
                    show-icon>
                </el-alert>
        </template>
    </div>

</template>

<script>
import { mapGetters } from 'vuex';

export default {

    components: {
    },

    props:{
        img:{
            type: String,
            required: false
        },
        imgPosY:{
            type: String,
            default: '0',
        },
        breadcrumb:{
            type: Boolean,
            default: true,
        },
        imgCover:{
            type: Boolean,
            default: true,
        },
        scopeClass:{
            type: String,
            default: '',
        },
        indicators:{
            type: Array,
            default(){
                return [];
            },
        },
        /* Display a loading spinner on top of the view */
        loading: {
            type: Boolean,
            default: false,
        },
        /* Do not display view until this flag is true */
        modelsLoaded: {
            type: Boolean,
            required: true,
        },
        name: {
            type: String,
            default(){
                return '';
            },
        },
        breadcrumbSubRoutes: {
            type: Array,
            default(){
                return [];
            },
        },
        userAllowedToAccess:{
            type: Boolean,
            required: false,
            default(){
                return true;
            },
        },
        userNotAllowedToAccessMessage:{
            type: String,
            required: false,
            default(){
                return '';
            },
        }
    },

    data: function(){
        return {

        };
    },

    computed: {
        ...mapGetters('fundation', [
            'burgerMenuClosed',
            'backgroundFile2',
            'getVerbose'
        ]),
        backgroundImg(){
            if(this.img){
                return this.img;
            }
            return this.backgroundFile2;
        },
        _userNotAllowedToAccessMessage(){
            if(this.userNotAllowedToAccessMessage){
                return this.userNotAllowedToAccessMessage;
            }
            return this.getVerbose('page_no_permission');
        }
    },

    watch: {

    },

    mounted: function(){

    },

    methods: {
    },
};
</script>

<style lang="scss">
.mainWrapper{
    margin-top: 65px;
    padding-bottom: 20px;
}
.pageHeader{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.menuClosed{
    // margin: 65px 0 0 59px;
    transition: ease-in-out .3s margin-left;
}

.menuOpened{
    // margin: 65px 0 0 230px;
    transition: ease-in-out .3s margin-left;
}

.simpleLayoutMainMenuClosed {
    // margin-left: 65px !important;
    transition: ease-in-out .3s margin-left;
}

.simple-layout .header {
  position: relative;
  overflow: hidden;
  height: 145px;
  background: black;

  .backgroundImage{
    opacity: .5;
    // background-size: auto;
    height: 145px;
    position: absolute;
    top: 0;
    left: 0;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
  }

  .projectHeaderContent {
    position: absolute;
    z-index: 2;
    color: white;
    width: 100%;
    height: 100%;
    font-size: 20px;
    font-family: Montserrat;
    .h1 {
      font-size: 45px;
      margin-top: 0;
      margin-bottom: 45px;
      font-weight: 200;
    }
    .ico {
      font-size: 40px;
    }
    .number {
        font-size: 40px;
        @media (min-width: 768px) {
            font-size: 64px;
        }
    }
    .desc {
      font-size: 20px;
    }
  }
}
.blured {
  background-size: 100%;
  -webkit-filter: blur(2px);
  z-index: 1;
}
.simple-layout-main{
    margin: 0 15px;
}

.simple-layout {
    background-color: #eeeeee;

    .select-group-component {
        float: right;
    }

    .infoHeader {
        text-align: center;
        color: white;
        padding: 15px 0;
        position: relative;
        .info {
            .nb {
                margin-top: 10px;
                font-size: 45px;
            }
        }


      .ring-container{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: .7;
        .lds-ring {
          display: inline-block;
          position: relative;
          width: 64px;
          height: 64px;
        p{
            color: white;
            text-transform: uppercase;
            position: absolute;
            top: 64px;
          }
        }
        .lds-ring div {
          box-sizing: border-box;
          display: block;
          position: absolute;
          width: 51px;
          height: 51px;
          margin: 6px;
          border: 6px solid #fff;
          border-radius: 50%;
          animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
          border-color: #fff transparent transparent transparent;
        }
        .lds-ring div:nth-child(1) {
          animation-delay: -0.45s;
        }
        .lds-ring div:nth-child(2) {
          animation-delay: -0.3s;
        }
        .lds-ring div:nth-child(3) {
          animation-delay: -0.15s;
        }
        @keyframes lds-ring {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

      }
    }

}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/simple-layout.vue